import {connect} from 'react-redux';

import {type UserStatus} from '@time-webkit/all/types/general';
import {getUser, getStatusForUserId} from 'mattermost-redux/selectors/entities/users';
import {shouldShowAvailabilityStatusOnPosts} from 'mattermost-redux/selectors/entities/preferences';
import {type Post} from 'mattermost-redux/types/posts';
import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';
import {getPostOverrideIconURL} from 'features/posts/selectors/get_post_override_icon_url';

import {type GlobalState} from 'types/store';

import PostProfilePicture from './post_profile_picture';

type Props = {
    userId: string;
    post: Post;
}

function mapStateToProps(state: GlobalState, ownProps: Props) {
    const user = getUser(state, ownProps.userId);
    const availabilityStatusOnPosts = shouldShowAvailabilityStatusOnPosts();

    return {
        availabilityStatusOnPosts,
        overrideUsername: getPostOverrideUsername(state, ownProps.post),
        overrideIconURL: getPostOverrideIconURL(state, ownProps.post),
        status: getStatusForUserId(state, ownProps.userId) as UserStatus,
        isBot: Boolean(user && user.is_bot),
        user,
    };
}

export default connect(mapStateToProps)(PostProfilePicture);
